import { Component, inject, Input } from '@angular/core';
import { RouterLinkFactory } from '@app/core/router/router-link.factory';
import { ColorService } from '@app/core/services/color.service';
import { Tag } from '@isophi/pap-api';

export type PapTagCategory = Tag & { categories: Array<Tag> };

@Component({
    selector: 'app-recommendations-cards',
    templateUrl: './recommendations-cards.component.html',
    styleUrls: ['./recommendations-cards.component.scss'],
    standalone: false
})
export class RecommendationsCardsComponent {
  protected readonly colorService = inject(ColorService);
  readonly links = inject(RouterLinkFactory);

  @Input() title?: string;
  @Input() variant: 'default' | 'compact' = 'default';
  @Input() categories: PapTagCategory[] = [];

  trackByUuid(_: number, item: Tag) {
    return item.uuid;
  }
}
